import { useState } from 'react'
import { CollapsibleCardGroupContext } from './collapsibleCardGroupContext'

type CollapsibleCardGroupProps = {
    children: React.ReactNode
    defaultOpenItemId?: string | null
}

export const CollapsibleCardGroup = ({ children, defaultOpenItemId = null }: CollapsibleCardGroupProps) => {
    const [openItemId, setOpenItemId] = useState<string | null>(defaultOpenItemId)
    const [hasInteracted, setHasInteracted] = useState(false)

    return (
        <CollapsibleCardGroupContext.Provider value={{ openItemId, setOpenItemId, hasInteracted, setHasInteracted }}>
            {children}
        </CollapsibleCardGroupContext.Provider>
    )
}
